import { Modal, Typography } from 'antd';

/**
 * Confirms deleting a collection. Open while `collection` is set.
 *
 * @param {{ id, name } | null} props.collection
 */
const DeleteCollectionModal = ({ collection, deleting = false, onConfirm, onCancel }) => (
	<Modal
		open={Boolean(collection)}
		title="Delete this collection?"
		okText="Delete"
		okButtonProps={{ danger: true, loading: deleting }}
		cancelText="Cancel"
		onOk={() => onConfirm(collection)}
		onCancel={onCancel}
		destroyOnHidden>
		<Typography.Paragraph type="secondary" style={{ margin: 0 }}>
			&ldquo;{collection?.name}&rdquo; will be removed from your collections. This can&apos;t
			be undone.
		</Typography.Paragraph>
	</Modal>
);

export default DeleteCollectionModal;
